import { NavLink } from "react-router-dom";
import { ChevronsLeft, ChevronsRight, X } from "lucide-react";
import { NAV } from "./nav";
import { useWorkspace } from "./WorkspaceContext";

const LOGO = "https://customer-assets.emergentagent.com/job_bizcommerce-19/artifacts/7hv4d1j9_LOGO%20PNG.png";

const Item = ({ item, collapsed, onNavigate }) => (
  <NavLink
    to={item.path}
    end={item.key === "home"}
    onClick={onNavigate}
    title={collapsed ? item.label : undefined}
    data-testid={`nav-${item.key}`}
    className={({ isActive }) =>
      `group relative flex items-center gap-3 rounded-lg px-3 py-2 text-[13px] transition-colors duration-150 ${
        isActive ? "bg-white/[0.08] text-white" : "text-slate-400 hover:text-white hover:bg-white/[0.04]"
      }`
    }
  >
    {({ isActive }) => (
      <>
        {isActive && <span className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-r bg-[#E8A33D]" />}
        <item.icon className={`h-[18px] w-[18px] shrink-0 ${isActive ? "text-[#E8A33D]" : ""}`} />
        {!collapsed && <span className="truncate">{item.label}</span>}
        {!collapsed && item.phase2 && <span className="ml-auto text-[9px] uppercase tracking-wider text-slate-500">Soon</span>}
      </>
    )}
  </NavLink>
);

export const Sidebar = ({ collapsed, onToggle, mobileOpen, onCloseMobile }) => {
  const { can, me } = useWorkspace();
  const items = NAV.filter((n) => can(n.roles));
  const content = (isMobile) => (
    <div className="h-full flex flex-col">
      <div className="h-16 flex items-center gap-3 px-4 border-b border-white/[0.06]">
        <img src={LOGO} alt="Veyronix" className="h-8 w-auto brightness-0 invert" />
        {(!collapsed || isMobile) && (
          <div className="leading-tight min-w-0">
            <div className="font-brand text-white text-sm font-bold tracking-[0.18em]">VEYRONIX</div>
            <div className="text-[10px] text-slate-400 truncate">{me?.organization?.business_name || "Workspace"}</div>
          </div>
        )}
        {isMobile && (
          <button onClick={onCloseMobile} className="ml-auto text-slate-400 hover:text-white" data-testid="sidebar-close-mobile"><X className="h-5 w-5" /></button>
        )}
      </div>
      <nav className="flex-1 overflow-y-auto px-2.5 py-4 space-y-0.5">
        {items.map((it) => <Item key={it.key} item={it} collapsed={collapsed && !isMobile} onNavigate={isMobile ? onCloseMobile : undefined} />)}
      </nav>
      {!isMobile && (
        <button
          onClick={onToggle}
          className="m-2.5 flex items-center gap-2 rounded-lg px-3 py-2 text-xs text-slate-400 hover:text-white hover:bg-white/[0.04] transition-colors"
          data-testid="sidebar-collapse-toggle"
        >
          {collapsed ? <ChevronsRight className="h-4 w-4" /> : <><ChevronsLeft className="h-4 w-4" /> Collapse</>}
        </button>
      )}
    </div>
  );
  return (
    <>
      <aside
        className={`hidden lg:block sticky top-0 h-screen bg-[#0B1530] shrink-0 transition-[width] duration-200 ${collapsed ? "w-[68px]" : "w-60"}`}
        data-testid="ws-sidebar"
      >
        {content(false)}
      </aside>
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-50" data-testid="ws-sidebar-mobile">
          <div className="absolute inset-0 bg-black/40" onClick={onCloseMobile} />
          <aside className="absolute left-0 top-0 bottom-0 w-64 bg-[#0B1530] animate-in slide-in-from-left duration-200">{content(true)}</aside>
        </div>
      )}
    </>
  );
};
